<template>
  <button class="inline-flex bg-blackly sm:p-2 p-1" @click="$emit('click')">
    <FullScreen class="hover:scale-110 shrink-0 size-12 transform" />
  </button>
</template>

<script>
import FullScreen from '@/components/icons/FullScreen.vue';
export default defineNuxtComponent({
  components: {
    FullScreen,
  },
});
</script>
